import React from 'react';
import { connect } from 'react-redux';
import '@/companys/scb/assets/styles/components/ipo/apply.scss';
import { getSafe } from '@/helpers/global';
import Details from '@/companys/scb/components/@app/IPO/Apply/Details';
import Terms from '@/companys/scb/components/@app/IPO/Apply/Terms';
import Prospectus from '@/companys/scb/components/@app/IPO/Apply/Prospectus';
import Apply from '@/companys/scb/components/@app/IPO/Apply/Apply';
import Preview from '@/companys/scb/components/@app/IPO/Apply/Preview';
import Result from '@/companys/scb/components/@app/IPO/Apply/Result';
import Margin from '@/companys/scb/components/@app/IPO/Apply/Margin';
import { Icons } from '@/configurations/app-configs/app-icons';
import { IPOActions } from '@/actions/trading';
import { Converter } from '../../../helpers/functions';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { REFRESH_DATA, IPO_MODE, IPO_PLAN } from '@/constants/app';
import classnames from 'classnames';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';

class ApplyPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      fail: false,
      failTips:false,
      isSelectStatement:false,
      marginFailTips:false,
      load: false,
      title: 'ipo_apply_details_header',
      detailData: [{ label: 'common_symbol', value: '-' },
      { label: 'common_name', value: '-' },
      { label: 'common_number_offer_shares', value: '-' },
      { label: 'common_number_public_offer_shares', value: '-' },
      { label: 'common_currency', value: '-' },
      { label: 'common_offer_price', value: '-' },
      { label: 'common_lot_size', value: '-' },
      { label: 'common_start_date_for_application', value: '-' },
      { label: 'common_end_time_for_application', value: '-' },
      { label: 'common_allotment_date', value: '-' },
      { label: 'common_end_time_for_online_application', value: '-' },
      { label: 'common_listing_date', value: '-' },
      { label: 'common_listed_exchange', value: '-' }],
      priceData: [],
      stepsData: [
        { id: 0, label: 'ipo_apply_detail_start', time: '-' },
        { id: 1, label: 'ipo_apply_detail_close', time: '-' },
        { id: 2, label: 'ipo_apply_detail_result', time: '-' },
        { id: 3, label: 'ipo_apply_detail_list', time: '-' },
      ],
      lotSpreadList: [],
      marginLotSpreadList: [],
      previewData: [],
      applyDataResp: {},
      resultResp: {},
      resultData: [
        { label: 'common_investment_account_no', value: '-' },
        props.mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_customer_name', value: '-' },
        { label: 'common_symbol_name', value: '-' },
        { label: 'common_currency', value: '-' },
        { label: 'common_offer_price', value: '-' },
        { label: 'common_lot_size', value: '-' },
        { label: 'common_subscription_no', value: '-' },
        { label: 'common_application_time', value: '-' },
        { label: 'common_allotment_date', value: '-' },
        { label: 'common_listing_date', value: '-' },
        { label: 'ipo_margin_apply_margin_percentage', value: '-' },
        { label: 'common_number_of_shares_apply', value: '-' },
        { label: 'common_subscription_amount', value: '-' },
        { label: 'ipo_service_charge', value: '-' },
      ],
      marginResultData: [
        { label: 'ipo_loan_interest', value: '-' },
        { label: 'ipo_settlemnt_account', value: '-' },
        { label: 'ipo_custormer_id', value: '-' },
        { label: 'ipo_correspondence_address', value: '-' },
        { label: 'ipo_contact_phone', value: '-' },
        { label: 'ipo_drawdown_date', value: '-' },
        { label: 'ipo_repayment_date', value: '-' },
        { label: 'ipo_deposit_amount', value: '-' },
      ],
      marginTopData: [],
      marginBottom: [],
      lendingPercentList: [],
      marginAction: false,
      MarginPreviewData: {},
      allowNextStep: false,
      errorMsg: '',
      marginErrorMsg:''
    }
  }

  getNextStep = () => {
    let { step, allowNextStep, applyDataResp  } = this.state;
    const { language,mode,currentTradingAccount }=this.props
    const { clientID, tradingAccSeq } = currentTradingAccount
    if (this.props.clientID && allowNextStep) {
      switch (step) {
        case 2: {
          let result = false
          for (let i = 0; i < this.prospectus.state.prospectus.length; i++) {
            if (!this.prospectus.state.prospectus[i].value) {
              result = true
            }
          }
          if (result) {
            this.setState({ fail: true })
            return
          } else {
            this.setState({ step: ++step })
          }
          break
        }
        case 3: {
          if (this.props.mode === IPO_MODE.MARGIN_APPLY_ACTION) {
            if(this.marginRef.state.InterestObj.loanAmount === ''){
              this.setState({ marginFailTips:true, marginErrorMsg:language.ipo_margin_apply_margin_no_input_loan_amount })
              return
            }else if(this.marginRef.state.InterestObj.loanAmount === '0'){
              this.setState({ marginFailTips:true, marginErrorMsg:language.ipo_margin_apply_margin_input_zero_loan_amount })
              return
            }else if(Number(this.marginRef.state.InterestObj.loanAmount)  > Number(this.marginRef.state.refAmount)){
              this.setState({ marginFailTips:true, marginErrorMsg:language.ipo_margin_apply_margin_fail_loan_amount })
              return
            }
            if(applyDataResp.lendingPercentList.length > 0){
              const params = {
                [PARAMS.CLIENT_ID]: clientID,
                [PARAMS.TRADING_ACCOUNT_ID]: clientID,
                [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
                [PARAMS.LANGUAGE]: language.lang,
                [PARAMS.ENTITLEMENT_ID]: applyDataResp.entitlementID,
                [PARAMS.LENDING_PERCENTAGE]: applyDataResp.lendingPercentList[0].leadingPercentage,
                [PARAMS.APPLIEDQTY]: String(parseFloat(this.marginRef.state.otherNumberSharesApply)),
                [PARAMS.LOAN_AMOUNT]: this.marginRef.state.loanAmount,
              }
              this.props.getQueryIPOInterestRatePlanFee(params, res=>{
                if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
                  this.setState({
                    MarginPreviewData:res,
                    previewData: Converter.mapApplyData(this.state.applyDataResp, this.marginRef.state.marginData, '', this.props.language,this.props.mode , res).previewData,
                    step: ++step,
                  })
                }else{
                  this.setState({
                    previewData: Converter.mapApplyData(this.state.applyDataResp, this.marginRef.state.marginData, '', this.props.language,this.props.mode ).previewData,
                    step: ++step,
                  })
                }
              })
            }else{
              this.setState({
                previewData: Converter.mapApplyData(this.state.applyDataResp, this.marginRef.state.marginData, '', this.props.language,this.props.mode ).previewData,
                step: ++step,
              })
            }
          } else {
            this.setState({
              previewData: Converter.mapApplyData(this.state.applyDataResp, this.priceRef.state.priceBottomData, '', this.props.language).previewData,
              step: ++step,
            })
          }
          break;
        }
        case 4: {
          let result = false
          for (let i = 0; i < this.Preview.state.prospectus.length; i++) {
            if (!this.Preview.state.prospectus[i].value) {
              result = true
            }
          }
          if (result) {
            this.setState({ failTips: true })
            return
          }else if(!this.Preview.state.isSelect && mode === IPO_MODE.MARGIN_APPLY_ACTION){
            this.setState({ failTips: false, isSelectStatement: true })
            return
          } else {
            this.ApplyResult()
            this.setState({ step: ++step })
          }
          break
        }
        default: {
          this.setState({ step: ++step })
          break;
        }
      }
    } else {

    }

  }
  getBackStep = () => {
    let { step, allowNextStep } = this.state;
    if (this.props.clientID && allowNextStep) {
      switch (step) {
        case 2: {
          this.setState({ step: --step , fail: false })
          break
        }
        case 3: {
          this.setState({ fail: false , step: --step, marginFailTips:false })
          break;
        }
        case 4: {
          this.setState({ failTips:false,isSelectStatement:false, step: --step, marginFailTips:false })
          break;
        }
        default: {
          this.setState({ step: --step })
          break;
        }
      }
    } else {

    }

  }
  componentDidUpdate(preState) {
    let { step } = this.state
    if (preState.step !== step) {
      this.handleChangeTitle()
    }
  }

  componentDidMount() {
    const { currentTradingAccount, language, data, mode } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    this.handleChangeTitle()
    this.setState({
      load: true
    })
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.ENTITLEMENT_ID]: data.entitlementID,
      [PARAMS.LOT_SPREAD_DETAIL]: 'Y',
      [PARAMS.CALCULATE_FEE_FLAG]: 'Y',
      [PARAMS.IPO_MARGIN]: mode === IPO_MODE.MARGIN_APPLY_ACTION ? data.enableMargin : ''
    }
    this.setState({
      marginAction: data.enableMargin === 'Y' ? true : false
    })

    this.props.getDetailEnquiry(params, res => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          allowNextStep: true,
          load: false
        })
        this.generateApplyData(res);

      } else {
        this.setState({
          load: false,
          allowNextStep: false,
          errorMsg: res.errorMessage
        })
      }
    })
  }

  generateApplyData = (applyDataResp) => {
    const {language} = this.props
    let arrList = []
    let detailDataList = Converter.mapApplyData(applyDataResp,'','',language).detailData
    detailDataList.map(item =>{
      if(item.label === 'common_listed_exchange'){
        if(item.value === 'HKEX' || item.value === 'MAMK' || item.value === 'SZMK'){
          item.value = language.common_market_hk
        }else if(item.value === 'MAMK'){
          item.value = language.common_market_ma
        }else if(item.value === 'SZMK'){
          item.value = language.common_market_sz
        }
      }else if(item.label === 'common_name'){
        if(language.title === 'zh_TW' || language.title === 'zh_CN'){
          item.value = applyDataResp.instrumentChineseShortName
        }else{
          item.value = applyDataResp.instrumentShortname
        }
      }
      arrList.push(item)
    })
    this.setState({
      detailData: arrList,
      stepsData: Converter.mapApplyData(applyDataResp,'','',language).stepsData,
      priceData: Converter.mapApplyData(applyDataResp,'','',language).priceData,
      lotSpreadList: Converter.mapApplyData(applyDataResp,'','',language).lotSpreadList,
      applyDataResp: applyDataResp
    }, () => {
      if (this.state.marginAction) {
        this.setState({
          marginTopData: Converter.mapMarginApplyData(applyDataResp,language),
          marginBottom: applyDataResp,
          lendingPercentList: Converter.mapApplyData(applyDataResp,'','',language).lendingPercentList,
          marginLotSpreadList: Converter.mapApplyData(applyDataResp,'','',language).marginLotSpreadList
        });
      }
    });

  }

  ApplyResult = () => {
    const { currentTradingAccount, language, data, mode } = this.props;
    const { applyDataResp } = this.state;
    const { clientID, tradingAccSeq } = currentTradingAccount
    this.setState({
      load: true
    })
    let params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
      [PARAMS.ENTITLEMENT_ID]: data.entitlementID,
      [PARAMS.INSTRUMENT_ID]: data.instrumentID,
      [PARAMS.MARKET_ID]: data.marketID,
      [PARAMS.LANGUAGE]: language.lang
    }
    if (mode === IPO_MODE.APPLY_ACTION) {
      params[PARAMS.QTY] = String(parseFloat(this.priceRef.state.subscriptionAmount))
    }
    if (mode === IPO_MODE.MARGIN_APPLY_ACTION && this.marginRef.state.financingPlan === IPO_PLAN.FIXED_PLAN) {
      params[PARAMS.FINANCING_PLAN] = this.marginRef.state.financingPlan;
      // params[PARAMS.LENDING_PERCENTAGE] = this.marginRef.state.FixedObj.lendingPercentage;
      params[PARAMS.FIXED_CHARGE] = this.marginRef.state.FixedObj.fixedCharge;
      params[PARAMS.QTY] = String(parseFloat(this.marginRef.state.FixedObj.applyShare));
    }
    if (mode === IPO_MODE.MARGIN_APPLY_ACTION && this.marginRef.state.financingPlan === IPO_PLAN.INTEREST_PLAN) {
      params[PARAMS.FINANCING_PLAN] = this.marginRef.state.financingPlan;
      // params[PARAMS.LENDING_PERCENTAGE] = this.marginRef.state.InterestObj.lendingPercentage;
      params[PARAMS.LOAN_AMOUNT] = this.marginRef.state.InterestObj.loanAmount;
      params[PARAMS.INTEREST_RATE_BASIS] = this.marginRef.state.InterestObj.interestRateBasis;
      params[PARAMS.INTEREST_RATE] = this.marginRef.state.InterestObj.interestRate;
      params[PARAMS.QTY] = String(parseFloat(this.marginRef.state.otherNumberSharesApply));

    }
    this.props.getApplyResult(params, res => {
      this.setState({
        resultResp: res,
        load: false,
        resultData: Converter.mapApplyData(applyDataResp, mode === IPO_MODE.APPLY_ACTION ? this.priceRef.state.priceBottomData : this.marginRef.state.marginData, res, language,mode).resultData,
        marginResultData: Converter.mapApplyData(applyDataResp, mode === IPO_MODE.APPLY_ACTION ? this.priceRef.state.priceBottomData : this.marginRef.state.marginData, res, language,mode).marginResultData
      })
      this.props.toggleRefreshTable(true)
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
      }
    })
  }

  handleChangeTitle() {
    const { language, data, mode } = this.props;
    const { step } = this.state;
    const el = document.getElementById('dialog_title');
    let key = '';
    switch (step) {
      case 0: key = 'ipo_apply_details'; break;
      case 1: key = 'ipo_apply_terms'; break;
      case 2: key = 'ipo_apply_prospectus'; break;
      case 3: {
        if (mode === IPO_MODE.MARGIN_APPLY_ACTION) {
          key = 'ipo_margin_apply'
        } else {
          key = 'common_apply';
        }
        break;
      }
      case 4: key = 'ipo_apply_preview'; break;
      case 5: key = 'ipo_apply_result'; break;
      default: break;
    }
    if (el) {
      const eventName = language[key];
      el.innerHTML = language.ipo_apply_application.format(eventName)
    }
  }

  resetOption = () => {
    const { mode } = this.props;
    if (mode === IPO_MODE.MARGIN_APPLY_ACTION) {
      this.setState({marginFailTips:false,marginErrorMsg:''})
      this.marginRef.reSetMargin()
    } else {
      this.priceRef.reSetSharesApply()
    }
  }

  render() {
    const { language, data, mode } = this.props;
    let { step, load, fail, failTips,isSelectStatement,marginFailTips, allowNextStep, detailData, stepsData, priceData, lotSpreadList, previewData, resultResp, resultData, marginTopData, marginBottom, lendingPercentList, marginLotSpreadList, applyDataResp, errorMsg, marginErrorMsg, marginResultData } = this.state
    return (
      <React.Fragment>
        <div className='apply-container'>
          <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
          {
            step === 0 && <Details detailData={detailData} stepsData={stepsData} data={data} applyDataResp={this.state.applyDataResp}/>
          }
          {
            step === 1 && <Terms />
          }
          {
            step === 2 && <Prospectus innerRef={e => this.prospectus = e} fail={fail} applyDataResp={this.state.applyDataResp}/>
          }
          {
            step === 3 && mode === IPO_MODE.APPLY_ACTION && <Apply innerRef={e => this.priceRef = e} priceData={priceData} lotSpreadList={lotSpreadList} applyDataResp={this.state.applyDataResp}/>
          }
          {
            step === 3 && mode === IPO_MODE.MARGIN_APPLY_ACTION && <Margin innerRef={e => this.marginRef = e} applyDataResp={applyDataResp} marginTopData={marginTopData} marginBottom={marginBottom} marginLotSpreadList={marginLotSpreadList} lendingPercentList={lendingPercentList} marginFailTips = {marginFailTips} marginErrorMsg= {marginErrorMsg}/>
          }
          {
            step === 4 && <Preview innerRef={e => this.Preview = e} previewData={previewData} ccy={data.currencyID} mode={mode} failTips={failTips} isSelectStatement={isSelectStatement}/>
          }
          {
            step === 5 && <Result load={load} resultResp={resultResp} resultData={resultData} mode={mode} marginResultData = { marginResultData }/>
          }
          {/* 
            Button Section
          */}
          {
            step === 1 && <div className="action-box">
            <button className="back" onClick={() => this.getBackStep()}>{getSafe(() => language.common_back)}</button>
            <button className={classnames('continue', allowNextStep ? '' : 'disable')} onClick={() => this.getNextStep()}>{getSafe(() => language.common_accept)}</button>
            </div>
          }
          {
            step === 0  && <button className={classnames('continue', allowNextStep ? '' : 'disable')} onClick={() => this.getNextStep()}>{getSafe(() => language.common_continue)}</button>
          }
          {
            step === 3 && <div className="action-box">
              <button className="back" onClick={() => this.getBackStep()}>{getSafe(() => language.common_back)}</button>
              <button className="clear" onClick={() => this.resetOption()}>{getSafe(() => language.common_clear)}</button>
              <button className="continue" onClick={() => this.getNextStep()}>{getSafe(() => language.common_preview)}</button>
            </div>
          }
          {
            step === 4 && <div className="action-box">
              <button className="back" onClick={() => this.getBackStep()}>{getSafe(() => language.common_back)}</button>
              <button className="continue" onClick={() => this.getNextStep()}>{getSafe(() => language.common_confirm)}</button>
            </div>
          }
          {
             step === 2 && <div className="action-box">
              <button className="back" onClick={() => this.getBackStep()}>{getSafe(() => language.common_back)}</button>
              <button className={classnames('continue', allowNextStep ? '' : 'disable')} onClick={() => this.getNextStep()}>{getSafe(() => language.common_continue)}</button>
             </div>
          }
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
  }),
  dispatch => ({
    getDetailEnquiry: (p, res) => dispatch(IPOActions.getDetailEnquiryAction(p, res)),
    getApplyResult: (p, res) => dispatch(IPOActions.getApplyResultAction(p, res)),
    getQueryIPOInterestRatePlanFee: (p, res) => dispatch(IPOActions.getQueryIPOInterestRatePlanFeeAction(p, res)),
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.IPO_ACTION,
      value: p
    })
  })
)(ApplyPlan)
